import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { ContextForClient } from "../../Context_file/ClientContext";
import { fetchRequest } from "../../helper/CustomFetch";

const ChannelUserHeaders = () => {
  const [{ resizeFlag }, dispatch] = useContext(ContextForClient);
  const fetchRandomPost = async () => {
    await dispatch({ type: "SHOW_ALL_CHANNEL", payload: false });
    const url = "randompost",
      storage = "randompost";
    await fetchRequest({ storage, url, dispatch });
  };

  return (
    <>
      {resizeFlag && (
        <section
          className={`container d-flex align-items-center`}
          style={{
            color: "#fff",
            transform: "translateY(20%)",
          }}
        >
          <h4>
            <FontAwesomeIcon
              icon={faAngleLeft}
              onClick={() => fetchRandomPost()}
              cursor="pointer"
            />
          </h4>
          <h4 className="text-capitalize mx-3">all channel</h4>
        </section>
      )}
    </>
  );
};

export default ChannelUserHeaders;
